<template>
  <div class="chart-menu">
    <div v-bind:class="'submenu_'+this.parentData">
      <div class="underline"></div>
      <div class="menuitem" @click="ul(index)" v-for="(item, index) in submenu[this.parentData].items" :key="index">
        <span class="menutext">{{item.name}}</span>
        <v-badge
          v-bind:color="item.activity > 0 ? '#25A7F9' : '#808F9C'"
          overlap
          class="align-self-center"
        >
          <template v-slot:badge>
            <span class="my-vbadge">{{item.activity}}</span>
          </template>
        </v-badge>
      </div>

      <div class="menuitem mr-4">
        <modalsSettings :type="this.parentData" />
      </div>
    </div>
  </div>
</template>

<script>
import modalsSettings from "./settings";

export default {
  props: ["parentData"],

  components: {
    modalsSettings
  },

  data() {
    return {
      name: "Submenu",
      dialog: false
      //selected: this.$store.getters.userSubmenus[this.parentData].selected
    };
  },
  computed: {
    submenu() {
      return this.$store.getters.userSubmenus;
    },
   
  },
  methods: {
    // submenu click

    ul(newSelection) {
      this.$store.dispatch("updateSubmenu", {
        section: this.parentData,
        value: newSelection
      });
       
      //if (this.parentData == 0) this.$store.dispatch("CHANGE_DATA", index);

      var selectedIndex = newSelection;
      //var itemsArray = this.$store.getters.userSubmenus[this.parentData].items;
      //var selectedIndex = itemsArray.indexOf(selectedItem);

      var menuitem = document.querySelectorAll(
        ".submenu_" + this.parentData + " .menuitem"
      );
      var menutext = document.querySelectorAll(
        ".submenu_" + this.parentData + " .menuitem .menutext"
      );

      for (var i = 0; i < menutext.length; i++) {
        menutext[i].style.color = null;
      }
      menutext[selectedIndex].style.color = "#FFFFFF";
      var width = menutext[selectedIndex].offsetWidth;
      var x = menuitem[selectedIndex].offsetLeft;
      var underlines = document.querySelectorAll(
        ".submenu_" + this.parentData + " .underline"
      );
      underlines[0].style.width = width + "px";
      underlines[0].style.transform = "translate3d(" + x + "px,0,0)";
    }
  },
  mounted() {
    
    if(this.parentData == "Section1" && this.$route.params.focus){
      //alert(this.$route.params.focus)
      if(this.$route.params.focus == "focusdiary") this.ul(1)
      if(this.$route.params.focus == "focusprepare") this.ul(2)
      setTimeout(() => {
        this.$vuetify.goTo("#focussection1", {offset: 100})
      },500)

      }
    
    //var itemsArray = this.$store.getters.userSubmenus[this.parentData].items;
    //var selectedIndex = itemsArray.indexOf(selectedItem);

    setTimeout(() => {
      var selectedIndex = this.$store.getters.userSubmenus[this.parentData]
      .selected;
      // initial submenut underline (after short timeout)
      var menuitem = document.querySelectorAll(
        ".submenu_" + this.parentData + " .menuitem"
      );
      var menutext = document.querySelectorAll(
        ".submenu_" + this.parentData + " .menuitem .menutext"
      );
      menutext[selectedIndex].style.color = "#FFFFFF";
      var width = menutext[selectedIndex].offsetWidth;
      var x = menuitem[selectedIndex].offsetLeft;
      var underlines = document.querySelectorAll(
        ".submenu_" + this.parentData + " .underline"
      );
      underlines[0].style.width = width + "px";
      underlines[0].style.transform = "translate3d(" + x + "px,0,0)";
    }, 200);
  }
};
</script>

<style scoped>

</style>
